import React, { useEffect } from 'react'
import CheckboxInput from '../inputs/checkbox-input'
import SelectInput from '../inputs/select-input'

const BoolMatch = ({data, types, columns, onRemove, onChange, onTransform}) => {
  const conditions = { true: 'is TRUE', false: 'is not TRUE' }

  const query = (params) => {
    return `${params.column} ${conditions[params.condition]}`
  }

  useEffect(() => {
    if (!data.condition) {
      const defaultParam = {...data, condition: false, completed: true}
      const defaultQuery = query(defaultParam)
      onChange({...defaultParam, query: defaultQuery})
    }
  }, [data.column])

  const changeData = (params) => {
    const newData = {...data, ...params}
    onChange({...data, ...params, query: query(newData)})
  }

  return <div className='filter-row'>
    { !data.type && <span className='where'>Where</span> }
    { data.type && 
      <SelectInput
        name='type'
        options={types}
        value={data.type}
        onChange={e => changeData({type: e.target.value})}
      />      
    }
    <SelectInput
      name='column'
      options={columns}
      value={data.column}
      onChange={e => onTransform(e.target.value)}
    />
    { data.condition != undefined && 
      <CheckboxInput
        name='bcondition'
        checked={data.condition}
        onChange={e => changeData({condition: e.target.checked})}
      />
    }
    <button className='remove' onClick={onRemove}><i className='fa fa-trash-o' /></button>
  </div>
}

export default BoolMatch
